export { SuiMessageModule } from "./index";
//# sourceMappingURL=public.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/collections/message/public.js
// module id = 1082
// module chunks = 0